import { Button, Form, InputNumber, Select, Typography } from "antd";
import { useEffect } from "react";

const { Text } = Typography;

const estiloQuadro = {
  border: "1px solid var(--ouran-card-header-bg)",
  borderRadius: 8,
  padding: "8px 16px 0",
  margin: 0,
  minWidth: 0,
};

const estiloTituloQuadro = {
  padding: "0 6px",
  width: "auto",
  margin: 0,
  border: 0,
  fontSize: 14,
  fontWeight: 600,
};

const GRUPOS = [
  {
    titulo: "Gravação",
    campos: [
      {
        name: "duracaoSegmentoMin",
        label: "Duração do segmento",
        unidade: "min",
        min: 1,
        max: 60,
      },
    ],
  },
  {
    titulo: "Envio",
    campos: [
      {
        name: "uploadKbpsMax",
        label: "Limite de upload",
        unidade: "kbps",
        min: 0,
        extra: "0 = sem limite",
      },
      {
        name: "uploadKbpsMaxHorarioComercial",
        label: "Limite no horário comercial",
        unidade: "kbps",
        min: 0,
      },
    ],
  },
  {
    titulo: "Disco e retenção",
    campos: [
      { name: "politicaDiscoCheio", label: "Disco cheio", politica: true },
      { name: "bufferMaximoGb", label: "Buffer máximo", unidade: "GB", min: 1 },
      {
        name: "diasRetencaoAposEnvio",
        label: "Manter após envio",
        unidade: "dias",
        min: 0,
      },
      {
        name: "diasMaximosSegmento",
        label: "Idade máxima do segmento",
        unidade: "dias",
        min: 1,
      },
    ],
  },
];

const CAMPOS = GRUPOS.flatMap((g) => g.campos.map((c) => c.name));

function mudou(valor, original) {
  return (valor ?? null) !== (original ?? null);
}

export default function ParametrosTab({ parametros, salvando, onSalvar }) {
  const [form] = Form.useForm();
  const valores = Form.useWatch([], form) || {};

  useEffect(() => {
    if (parametros) form.setFieldsValue(parametros);
  }, [parametros, form]);

  const alterados = CAMPOS.filter((c) => mudou(valores[c], parametros?.[c]));

  const salvar = (dados) => {
    const mudancas = Object.fromEntries(
      alterados.map((campo) => [campo, dados[campo]])
    );
    onSalvar(mudancas);
  };

  return (
    <Form form={form} layout="vertical" requiredMark={false} onFinish={salvar}>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "max-content max-content 1fr",
          gap: 16,
        }}>
        {GRUPOS.map((grupo, i) => (
          <fieldset key={grupo.titulo} style={estiloQuadro}>
            <legend style={estiloTituloQuadro}>{grupo.titulo}</legend>
            <div
              style={{
                display: "flex",
                flexWrap: i === GRUPOS.length - 1 ? "wrap" : "nowrap",
                columnGap: 24,
              }}>
              {grupo.campos.map((campo) => (
                <Form.Item
                  key={campo.name}
                  name={campo.name}
                  label={campo.label}
                  extra={campo.extra}
                  rules={[{ required: true, message: "Obrigatório." }]}>
                  {campo.politica ? (
                    <Select
                      style={{ width: 220 }}
                      status={
                        mudou(valores[campo.name], parametros?.[campo.name])
                          ? "warning"
                          : ""
                      }
                      options={[
                        {
                          value: "descartar_antigos",
                          label: "Descartar os mais antigos",
                        },
                        { value: "parar", label: "Parar a gravação" },
                      ]}
                    />
                  ) : (
                    <InputNumber
                      min={campo.min}
                      max={campo.max}
                      precision={0}
                      status={
                        mudou(valores[campo.name], parametros?.[campo.name])
                          ? "warning"
                          : ""
                      }
                      addonAfter={
                        <span
                          style={{
                            display: "inline-block",
                            width: 36,
                            textAlign: "center",
                          }}>
                          {campo.unidade}
                        </span>
                      }
                      style={{ width: 160 }}
                    />
                  )}
                </Form.Item>
              ))}
            </div>
          </fieldset>
        ))}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          marginTop: 16,
        }}>
        <Button
          type="primary"
          htmlType="submit"
          loading={salvando}
          disabled={alterados.length === 0}>
          Salvar alterações
        </Button>
        <Button
          onClick={() => form.setFieldsValue(parametros)}
          disabled={alterados.length === 0}>
          Descartar
        </Button>
        {alterados.length > 0 && (
          <Text type="warning">
            {alterados.length === 1
              ? "1 campo alterado"
              : `${alterados.length} campos alterados`}
          </Text>
        )}
      </div>
    </Form>
  );
}
